module.exports = __webpack_public_path__ + "img/JC_her.311b67c1.png";